export default __webpack_public_path__ + "static/media/logo-black.584a5ea4.svg";